import {TextField} from '@wandb/weave/components/Form/TextField';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {components, MenuProps} from 'react-select';

interface SearchableMenuProps<OptionType> extends MenuProps<OptionType, false> {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
}

/**
 * Generic menu component with a search input at the top
 */
export function SearchableMenu<OptionType>({
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Search...',
  children,
  ...props
}: SearchableMenuProps<OptionType>) {
  return (
    <components.Menu {...props}>
      <Tailwind>
        <div
          className="p-8 border-b rounded-t border-moon-200 bg-white sticky top-0 z-10"
          onClick={e => {
            // Prevent menu from closing when clicking on search box
            e.stopPropagation();
          }}
          onMouseDown={e => {
            // Prevent menu from closing when clicking on search box
            e.stopPropagation();
          }}>
          <TextField
            size="medium"
            placeholder={searchPlaceholder}
            value={searchTerm}
            onChange={onSearchChange}
            icon="search"
            autoFocus
            onKeyDown={(key, e) => {
              // Prevent react-select from capturing these keys
              if (
                key === 'Backspace' ||
                key === 'Delete' ||
                key === 'ArrowLeft' ||
                key === 'ArrowRight' ||
                key === 'Home' ||
                key === 'End'
              ) {
                e.stopPropagation();
              }
            }}
          />
        </div>
      </Tailwind>
      {children}
    </components.Menu>
  );
}
